const disputeClaimsNL = {
    "view": {
        "table": {
            "title": "Uw Auteursrechtenschendingen",
            "columns": {
                "release": "Release",
                "user": "Gebruiker",
                "store": "Winkel",
                "claimantName": "Naam Aanspraakmaker",
                "claimantEmail": "E-mail Aanspraakmaker",
                "resolutionTime": "Oplostijd",
                "remainingTime": "Resterende Tijd",
                "status": "Status"
            },
            "label": {
                "status_created": "Gemaakt",
                "status_pending": "In Afwachting",
                "status_in_progress": "In Behandeling",
                "status_resolved": "Opgelost",
                "status_copyright_violation": "Auteursrechtenschending"
            },
            "button": {
                "exportCSV": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            }
        }
    }
};

export default disputeClaimsNL;